<template>
  <base-dialog
    width="560px"
    show-close
    :visible.sync="visible"
    class="setting-validate-rule-dialog"
  >
    <template v-slot:header>编辑规则</template>
    <el-form ref="form" :model="condition" label-width="110px" :rules="rules" label-position="left">
      <el-form-item prop="msg">
        <template slot="label">
          <span class="require-flag">*</span>
          规则名称
        </template>
        <textarea-editor
          v-if="visible"
          v-model="conditionName"
          :var-group="flowVarGroup"
          min-height="100"
        ></textarea-editor>
      </el-form-item>
      <el-form-item label="校验条件" prop="filters">
        <div>
          <span>满足条件时阻断操作</span>
          <div class="content-item">
            <condition-list
              class="condition-list"
              :conditions="condition.filters"
              :workflow-var-list="flowConnectedData"
              from="validate_rule"
            ></condition-list>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import mixin from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/mixin"
import TextareaEditor from "@/components/UIComponents/TextareaEditor"
import _ from "lodash"

export default {
  name: "setting-validate-rule-dialog",
  components: { BaseDialog, BaseButton, ConditionList, TextareaEditor },
  props: {
    flowConnectedData: Array,
    validateExtra: Object,
    workflowVarGroupStringMap: Object,
    flowVarGroup: Array
  },
  mixins: [mixin],
  data() {
    return {
      visible: false,
      conditionName: { msgShow: "", arr: [], text: "" },
      condition: {},
      rules: {
        msg: [
          {
            validator: (rule, value, callback) => {
              if (this.conditionName.text == undefined) callback("请填写规则名称")
              callback()
            },
            trigger: "blur"
          }
        ],
        filters: [{ required: true, message: "请设置规则" }]
      },
      allDefaultControls: []
    }
  },
  methods: {
    open(condition) {
      condition = condition ? this._.cloneDeep(condition) : {}
      condition.filters = this.transFilters(condition?.filters || []) || []
      this.condition = condition
      this.conditionName.msgShow = condition.msgShow
      this.conditionName.arr = this.validateExtra.conditionMap?.rules
        ? this.validateExtra.conditionMap.rules[condition.msgShow]
        : []
      this.conditionName.text = condition.msg
      this.visible = true
    },
    submitExtra() {
      // 将收集到的规则名称提交给extra存储，用来展示
      let msg = this.condition.msg
      let msgArr = msg.split("+")
      let result = ""
      msgArr.forEach(m => {
        result = result + (m.includes("dealNull") ? this.workflowVarGroupStringMap[m] : m)
      })
      this.conditionName.msgShow = result.replace(/'/g, " ")
      let rule = {}
      rule[this.conditionName.msgShow] = this.conditionName.arr
      let ruleMap = {}
      ruleMap = Object.assign(
        this.validateExtra.conditionMap?.ruleMap ? this.validateExtra.conditionMap?.ruleMap : {},
        rule
      )
      this.$set(this.validateExtra, "conditionMap", {
        ruleMap
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.condition.msg = this.conditionName.text
        this.submitExtra()
        this.condition.msgShow = this.conditionName.msgShow
        this.$emit("submit", this.condition)
        this.visible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-validate-rule-dialog {
  .el-select {
    width: 100%;
  }
  .condition-list {
    ::v-deep {
      .add-condition-btn {
        margin-top: 0;
      }
    }
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
      color: unset;
    }
  }
}
</style>
